export default __webpack_public_path__ + "static/media/bbp-scheduler-large.8719ee51.png";